export enum AssetFileType {
    FILE = 'file',
    IMAGE = 'image',
    VIDEO = 'video',
    AUDIO = 'audio',
    FOLDER = 'folder',
    FONT = 'font',
    TEXT = 'text',
    LOTTIE = 'lottie',
    JSON = 'json',
    NONE = '',
}
